<form *ngIf="showGroupItemDetail" [formGroup]="dynaGroupItemForm" autocomplete="off" novalidate="" style="margin-bottom: 10px;">
    <div class="form-group row">
        <div style="display:none">
            <input class="form-control form-control-sm" formControlName="name">
        </div>
        <div style="display:none">
            <input class="form-control form-control-sm" formControlName="ID">
        </div>
        <div style="display:none">
            <input class="form-control form-control-sm" formControlName="groupID">
        </div>
        
        <div class="col-sm-5">
            <label>Display Name : </label>
        </div>
        <div class="col-sm-7">
            <input class="form-control form-control-sm" formControlName="displayName">
        </div>
        <div *ngIf="isVisible" class="col-sm-5">
            <label>Visible: </label>
        </div>
        <div *ngIf="isVisible" class="col-sm-7">
            <input class="form-check-input position-static" type="checkbox" formControlName="visible" style="margin-left: 0px;">
        </div>
        
        <div *ngIf="isHeaderVisible" class="col-sm-5 ">
            <label>Display Order : </label>
        </div>
        <div  *ngIf="isHeaderVisible" class="col-sm-7">
            <select (change)="changeOrder(order)"   formControlName="displayOrder" class="form-select form-select-sm" #order>
                <option *ngFor="let do of displayOrders"  [value] = "do" >{{do}}</option>
              </select> 
        </div>
                
        <div class="col-sm-12">
            <button type="button" class="btn btn-sm btn-secondary"
                 (click)="updateFormValues(dynaGroupItemForm.value,'update')">Update</button>
        </div>
    </div>
</form>
<div class="row">
    
    <div class="col-md-12">
        <div class="createGpAlign">
            <!--<span id="">
                <button class="btn btn-sm btn-secondary"
                (click)="createNewGroup()" [disabled] = "showGroupItemDetail">
                Create Group</button>
            </span>-->
        </div>
        <table class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    <span style="color:green;"> Available For Groups</span>
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' id="UnAssignedElements">
                <tr [id]="uie.InterfaceElementID"  *ngFor="let uie of unAssignedElements" >
                    <td [attr.data-id]="uie.InterfaceElementID" >{{uie.DisplayProperties.DisplayName}} 
                       <span style="visibility:hidden" id="{{wizardCode}}{{uie.InterfaceElementID}}">
                            <button class="btn btn-sm btn-secondary"
                            (click)="editdynaEditorItem(uie)">
                            <i id="button_DynaEdit" style="color:white"></i></button>
                        </span>
                    </td> 
                </tr>
            </tbody>
        </table>
    </div>

    <!--<div class="wrapper" dragula="COLUMNS" [(dragulaModel)]="groups1">
        <div class="container" *ngFor="let group of groups1">
         <table class="table  table-sm ">
            <thead class="dragula-thead">
               <th><span [id]="group.name" class="group-handle">{{group.name}}</span>
           
                    <span *ngIf="(group.InterfaceElementID != 'NO-ID')" id="{{wizardCode}}{{group.InterfaceElementID}}">
                        <button class="btn btn-sm btn-secondary"
                        (click)="editdynaEditorItem(group.ie)">
                        <i id="button_DynaEdit" style="color:white"></i>
                    </button>
                    </span></th>
            </thead>
                <div class="container" dragula="ITEMS" [id]="group.InterfaceElementID" [(dragulaModel)]="group.InterfaceElements">
                    <div [id]="gie.InterfaceElementID" *ngFor="let gie of group.InterfaceElements">
                      <span>{{gie.DisplayProperties.DisplayName}}</span>
                      <span id="{{wizardCode}}{{gie.InterfaceElementID}}">
                        <button class="btn btn-sm btn-secondary"
                        (click)="editdynaEditorItem(gie)">
                        <i id="button_DynaEdit" style="color:white"></i>
                    </button>
                    </span>
                    </div>
                </div>
          </table>
        </div>
    </div>-->
   
    <div *ngFor="let group of groups" [class]="groupAssignedSpace">
        <table class="table  table-sm">
            <thead class="dragula-thead">
                <th>
                    <span [ngClass]="group.Attributes.Visible == false ? 'visibleStatus': ''">{{group.Attributes.DisplayOrder}}-{{group.Label.DisplayName}}</span>
                    <span id="{{wizardCode}}{{group.InterfaceElementID}}">
                        <button class="btn btn-sm btn-secondary"
                        (click)="editdynaEditorItem(group)">
                        <i id="button_DynaEdit" style="color:white"></i>
                    </button>
                    </span>
                </th>
            </thead>
            <tbody class="dragula-tbody" [dragula]='"entity-items"' [id]="group.InterfaceElementID">
                <tr [id]="gie.InterfaceElementID"  *ngFor="let gie of group.InterfaceElements" >
                    <td [attr.data-id]="gie.InterfaceElementID" [ngClass]="gie.Attributes.Visible == false ? 'visibleStatus': ''" >{{gie.DisplayProperties.DisplayName}}
                        <span id="{{wizardCode}}{{gie.InterfaceElementID}}">
                            <button class="btn btn-sm btn-secondary"
                            (click)="editdynaEditorItem(gie)">
                            <i id="button_DynaEdit" style="color:white"></i>
                        </button>
                        </span>
                    </td> 
                </tr>
            </tbody>
        </table>
    </div>
</div>
